import React from "react";
import "../assets/styles/components/Caracteristiques.css";

import caracteristiques from "../data/Caracteristiques";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CaracteristiquesList = () => {
  return (
    <div className="container py-5">
      <h2 className="text-center">Caractéristiques</h2>
      <div className="row">
        {caracteristiques.map((item) => (
          <div key={item.id} className="col-md-4 col-sm-6 mb-4">
            <div className="list-item d-flex align-items-center">
              <FontAwesomeIcon icon={item.icon} className="me-3 violet-foncee" size="2x" />
              <span>{item.name}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CaracteristiquesList;
